//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import {
  IInsightsGalleriesPagesState,
  IInsightsGalleriesPageState,
  ReelIdType,
} from '@insights/redux/galleries/insightsGalleriesModel';
import { UnifiedMetricsTouchpointStatsResponse } from '@bvengineering/metrics-gateway-service-types';
import { InsightsSourceType } from '@apis/metrics/metricsApiModel';
import { GalleriesClientType } from '@galleries/selectors/getGalleriesClientType';

export const updateExistingGallery = (
  galleryId: ReelIdType,
  state: IInsightsGalleriesPagesState,
  updateFunc: (gallery: IInsightsGalleriesPageState) => void,
) => {
  const gallery = PojoMap.get(state.galleries, galleryId);
  if (gallery) {
    updateFunc(gallery);
  }
};

export const getTouchpointLabel = (
  touchpoint: UnifiedMetricsTouchpointStatsResponse['touchpoint'],
  galleryClientType?: GalleriesClientType,
) => {
  switch (touchpoint) {
    case InsightsSourceType.REEL:
      if (galleryClientType === GalleriesClientType.instashop) {
        return 'Instashop';
      }
      return 'Galleries';
    case InsightsSourceType.L2B:
      return 'Like2Buy';
    case InsightsSourceType.WIDGET:
      return 'Reveal';
    case InsightsSourceType.TRIBUTARY:
      return 'Showroom';
    default:
      return touchpoint;
  }
};
